import Swiper from "swiper";
import {A11y, Navigation, Pagination} from "swiper/modules";

function shuffleSlides(wrapper) {
  const slides = Array.from(wrapper.children)

  for (let i = slides.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    let temp = slides[i]
    slides[i] = slides[j]
    slides[j] = temp
  }

  slides.forEach(slide => wrapper.appendChild(slide))
}

export default function InitHeroSlider(nextSlideMessage, prevSlideMessage) {
  const heroSliderElements = document.querySelectorAll('.hero-slider')

  for (const heroSliderElement of heroSliderElements) {

    if (heroSliderElement.dataset["randomize"] === "true") {
      shuffleSlides(heroSliderElement.querySelector('.swiper-wrapper'))
    }

    const heroSliderSlides = Array.from(document.querySelectorAll('.hero-slider__slide'))

    const buttonColors = heroSliderSlides.map((slideElement) => (
      slideElement.dataset.buttonColor ?? 'light'
    ))

    const swiperEl = heroSliderElement.querySelector('.swiper')
    if (!swiperEl) continue

    const navigationButtons = heroSliderElement.querySelectorAll('.hero-slider__navigation-button')

    let heroSlider = new Swiper(swiperEl, {
      modules: [Navigation, Pagination, A11y],
      pagination: {
        el: heroSliderElement.querySelector('.swiper-pagination'),
        clickable: true,
        paginationHide: false,
      },
      navigation: {
        nextEl: '.hero-slider__navigation-button--next',
        prevEl: '.hero-slider__navigation-button--prev',
      },
      a11y: {
        enabled: true,
        nextSlideMessage: nextSlideMessage,
        prevSlideMessage: prevSlideMessage
      },
      loop: true,
      on: {
        slideChangeTransitionStart: (swiper) => {
          for (const navigationButton of navigationButtons) {
            navigationButton.dataset.buttonColor = buttonColors[swiper.realIndex]
          }
        }
      }
    })

    const autoplayDelay = 5000

    const slideNext = () => { if (heroSlider.wrapperEl && !heroSlider.animating) heroSlider.slideNext() }
    let autoplayTimer = setInterval(slideNext, autoplayDelay)

    heroSliderElement.addEventListener('mouseover', () => {
      clearInterval(autoplayTimer)
      autoplayTimer = null
    })

    heroSliderElement.addEventListener('mouseout', () => {
      if (!autoplayTimer) {
        autoplayTimer = setInterval(slideNext, autoplayDelay)
      }
    })
  }
}
